import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col } from 'reactstrap';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
// import { makeStyles } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { deepOrange, deepPurple } from '@mui/material/colors';
import Badge from '@mui/material/Badge';

import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import './chat.css';
import ChatMsg from './ChatMsg';
import { useNavigate } from 'react-router-dom';
import ChatBot from './ChatBot';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: '100%',
//     maxWidth: 360,
//     minWidth: 250,
//     color: 'black',
//   },
//   orange: {
//     color: theme.palette.getContrastText(deepOrange[500]),
//     backgroundColor: deepOrange[500],
//   },
//   blue: {
//     color: theme.palette.getContrastText(deepPurple[500]),
//     backgroundColor: deepPurple[500],
//   },
// }));
const Chat = () => {
  let navigate = useNavigate();
  // const classes = useStyles();

  const [students, setStudents] = useState([]);
  const [chatStudents, setChatStudents] = useState([]);
  const [currentChat, setCurrentChat] = useState([]);
  const [messagesFirestoreData, setMessagesFirestoreData] = useState({});
  const [firstTimeSeq, setFirstTimeSeq] = useState(true);
  const [currentChatID, setCurrentChatID] = useState('');
  const [currentStudents, setCurrentStudent] = useState('');

  useEffect(() => {
    getStudents();
    getMessages();
  }, []);

  // useEffect(() => {
  //   getMessages();
  // }, [currentStudents]);
  let unsubscribe;
  const switchChat = (userId) => {
    if (unsubscribe) unsubscribe(); // Unsubscribe from the previous listener

    // Set up new listener for the selected user
    unsubscribe = db
      .collection('Chats2')
      .where('userID', '==', userId)
      .orderBy('createdAt', 'desc')
      .onSnapshot((snapshot) => {
        let newMessages = [];
        snapshot.forEach((doc) => {
          const message = doc.data();
          newMessages.push({
            ...message,
            createdAt: message.createdAt
              ? message.createdAt.toDate()
              : new Date(),
          });
        });
        setCurrentChat(newMessages);
      });
  };

  useMemo(() => {
    if (
      students &&
      students.length > 0 &&
      Object.keys(chatStudents).length > 0 &&
      firstTimeSeq
    ) {
      setFirstTimeSeq(false);
      // console.log('currentID' ,currentChatID,)

      setStudents((prev = []) =>
        prev
          .map((item) => {
            // console.log('currentID',  item._uniqueID)
            return chatStudents[item._uniqueID]
              ? currentChatID == item._uniqueID
                ? {
                    ...item,
                    createdAtChat: chatStudents[item._uniqueID],
                    selectedChat: true,
                  }
                : { ...item, createdAtChat: chatStudents[item._uniqueID] }
              : item;
          })
          .sort((a, b) => {
            if (a.createdAtChat < b.createdAtChat) {
              return 1;
            }
            if (a.createdAtChat > b.createdAtChat) {
              return -1;
            }
            return 0;
          })
      );
    }
  }, [chatStudents, students]);

  const getMessages = () => {
    let chatId = {};
    let data = [];
    let today = new Date();
    let lastweek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 10
    );

    document.querySelector('#loading-indicator').style.display = 'flex';
    db.collection('Chats2')
      .orderBy('createdAt', 'desc')
      .where('createdAt', '>', lastweek)
      .onSnapshot((querySnapshot) => {
        querySnapshot
          .docChanges()
          .filter(({ type }) => type == 'added')
          .forEach(({ doc }) => {
            let message = doc.data();
            console.log('chatmessage', doc);
            data.push(message);
            message.user.id = message.user._id;
            if (!chatId[message.userID]) {
              chatId[message.userID] = [];
            }

            if (querySnapshot.docChanges().length !== 1) {
              chatId[message.userID].push({
                ...message,
                createdAt: message.createdAt.toDate(),
              });
            } else {
              if (document.getElementById('messageIn')) {
                document.getElementById('messageIn').play();
              }

              chatId[message.userID].splice(0, 0, {
                ...message,
                createdAt: message.createdAt.toDate(),
              });
              setStudents((prev = []) =>
                prev
                  .map((item) => {
                    return item._uniqueID == message.userID
                      ? {
                          ...item,
                          createdAtChat: message.createdAt.toDate(),
                          showBadge:
                            message.user.id === 'admin' ||
                            currentStudents == message.user.id
                              ? false
                              : true,
                        }
                      : item;
                  })
                  .sort((a, b) => {
                    if (a.createdAtChat < b.createdAtChat) {
                      return 1;
                    }
                    if (a.createdAtChat > b.createdAtChat) {
                      return -1;
                    }
                    return 0;
                  })
              );
            }
          });
        console.log('limit check', data.length);
        let temp = {};
        Object.keys(chatId).map((item) => {
          temp[item] = chatId[item][0].createdAt;
          return { createdAt: chatId[item][0].createdAt, id: item };
        });
        setChatStudents(temp);

        setMessagesFirestoreData(chatId);

        if (currentChat.length === 0 || !currentChat) {
          // console.log('Object.keys(chatId)[0]',Object.keys(chatId)[0])
          // console.log('chatId[Object.keys(chatId)[0]]',chatId[Object.keys(chatId)[0]])

          setCurrentChatID(Object.keys(chatId)[0]);
          setCurrentChat(chatId[Object.keys(chatId)[0]]);
        }
        if (currentStudents) {
          setCurrentChat(chatId[currentStudents]);
        }
      });
    document.querySelector('#loading-indicator').style.display = 'none';
  };

  const getStudents = () => {
    db.collection('zSystemStudents')
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs
          .map((doc, i) => {
            const { firstname, lastname, email } = doc.data();
            if (firstname !== undefined && lastname !== undefined) {
              return {
                firstname,
                lastname,
                email,
                _uniqueID: doc.id,
                createdAtChat: new Date(1970),
                showBadge: false,
                selectedChat: false,
              };
            } else {
              return null;
            }
          })
          .filter((item) => item);
        setStudents(data);
        console.log('limit check', data.length);
      });
  };

  const changeStudent = (id) => {
    setCurrentStudent(id);
    setCurrentChat(messagesFirestoreData[id]);
    setStudents((prev = []) => {
      return prev.map((item) => {
        return item._uniqueID == id
          ? { ...item, showBadge: true, selectedChat: true }
          : { ...item, showBadge: false, selectedChat: false };
      });
    });

    switchChat(id);
  };

  useEffect(() => {
    if (!currentStudents && currentChat?.length > 0) {
      console.log('aaaa');
      changeStudent(currentChat[0]?.userID);
    }
  }, [currentChat]);

  console.log(students, currentChat, 'student');
  return (
    <>
      <Row
        style={{
          justifyContent: 'flex-end',
          backgroundColor: '#1e1e2a',
          width: '100vw',
          margin: 0,
        }}
      >
        <Col sm={1} style={{ textAlign: 'center' }}>
          <IconButton
            style={{ color: 'white' }}
            edge='start'
            aria-label='close'
          >
            <CloseIcon
              onClick={() => {
                navigate(-1);
              }}
              //  onClick={handleClose}
            />
          </IconButton>
        </Col>
      </Row>

      <div
        className='scrollNone'
        style={{
          display: 'flex',
          backgroundColor: '#1e1e2a',
          height: '100%',
          overflow: 'auto',
        }}
      >
        <div
          className='scrollNone'
          style={{
            backgroundColor: '#272a3d',
            padding: '0px',
            paddingBottom: '20px',
            marginLeft: '20px',
            marginBottom: '12px',
            overflow: 'auto',
            minWidth: '300px',
            borderRadius: '8px',
          }}
        >
          <div style={{ padding: '20px' }}>
            <h6>Users</h6>
          </div>
          <List
            style={{
              width: '100%',
              maxWidth: 360,
              minWidth: 250,
              color: 'black',
            }}
          >
            {students?.length > 0 &&
              students.map((item, i) => {
                return (
                  <>
                    <ListItem
                      alignItems='flex-start'
                      key={item._uniqueID}
                      style={
                        item.selectedChat
                          ? { backgroundColor: 'cadetblue' }
                          : { cursor: 'pointer', borderRadius: '8px' }
                      }
                      onClick={() => changeStudent(item._uniqueID)}
                    >
                      <ListItemAvatar style={{ marginRight: '5px' }}>
                        <Avatar
                          alt={item.firstname}
                          src='/static/images/avatar/1.jpg'
                          // style={{i % 2 == 0 ? classes.orange : classes.blue}}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                        primary={`${item.firstname} ${item.lastname}`}
                        secondary={item.email}
                      />

                      {item.showBadge && (
                        <Badge
                          color='error'
                          variant='dot'
                          style={{ top: '30px', right: '10px' }}
                        ></Badge>
                      )}
                    </ListItem>
                  </>
                );
              })}
          </List>
        </div>
        <div style={{ width: '100%', position: 'relative' }}>
          {!currentChat && (
            <div
              style={{
                position: 'absolute',
                fontSize: 20,
                color: '#fff',
                left: 'calc( 50% - 70px)',
                top: '44%',
              }}
            >
              No chat history!
            </div>
          )}
          <div style={{ padding: '20px', paddingBottom: '0px' }}>
            <h6>Chat</h6>
          </div>
          <div style={styles.container}>
            <ChatBot
              setIsChatWidget={() => {}}
              chatMessages={currentChat}
              setChatMessages={setCurrentChat}
              currentStudent={currentStudents}
            />
            {/* {ChatMsg({
              studentId: currentStudents
                ? currentStudents
                : students[0]?._uniqueID,
              currentChat,
              messagesFirestoreData,
              userId: localStorage.getItem('uid'),
            })} */}
          </div>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    height: '80vh',
    margin: '20px',
  },
  chat: {
    display: 'flex',
    flex: 3,
    border: '#2873f5',
    borderStyle: 'solid',
    borderWidth: '1px',
  },
};
export default Chat;
